import { motion } from "framer-motion";
import { STEPS } from "../data/content";
import { SectionHeading, stagger, fadeUp } from "../lib/motion";
import { t } from "../i18n";

const HowItWorks = () => (
  <section id="process" data-testid="how-it-works-section" className="relative py-24 lg:py-32 bg-navy overflow-hidden">
    <div className="absolute inset-0 opacity-[0.03] font-display font-black text-[24vw] leading-none text-white pointer-events-none select-none whitespace-nowrap -translate-y-10">
      PROCESS
    </div>
    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <SectionHeading
        eyebrow={t("process.eyebrow")}
        title={t("process.title")}
        description={t("process.desc")}
        testid="process-heading"
      />
      <motion.div
        variants={stagger}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, margin: "-60px" }}
        className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6"
      >
        {STEPS.map((s, i) => (
          <motion.div key={s.num} variants={fadeUp} data-testid={`process-step-${s.num}`} className="relative glass-card rounded-2xl p-8 card-lift">
            {i < STEPS.length - 1 && (
              <span className="hidden lg:block absolute top-12 -right-3 h-px w-6 bg-gold/40" />
            )}
            <span className="font-display text-5xl font-black gold-gradient-text">{s.num}</span>
            <h3 className="font-display text-lg font-bold text-white mt-5 mb-2.5 tracking-tight">{t(`process.items.${i}.title`, s.title.toUpperCase())}</h3>
            <p className="text-sm text-slate-400 leading-relaxed">{t(`process.items.${i}.text`, s.text)}</p>
          </motion.div>
        ))}
      </motion.div>
    </div>
  </section>
);

export default HowItWorks;
